import React, { useEffect, useState } from "react";
import styles from "./ThemesGallery.module.scss";
import NoDataFound from "../../NoDataFound/NoDataFound";
import imgNotFound from "../../../assets/images/single-image.png";

import Skeleton from "react-loading-skeleton";
import NewUiHeader from "../NewUIHeader/NewUIHeader";
const ThemesGallery = ({ heading }) => {
  const token = localStorage.getItem("token");
  const [themes, setThemes] = useState([]);
  const [loader, setLoader] = useState(true);

  const fetchThemesDetails = () => {
    setLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/website/themes/list`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setThemes(data?.data?.slice(0, 10));
          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching  details:", error);
      });
  };

  useEffect(() => {
    fetchThemesDetails();
  }, []);

  return (
    <div className="" >
      <div className="container">
        {loader ? (
          <div>
            <div className="mt-20">
              <Skeleton width={300} height={30} />
            </div>
            <div className={styles.destination_gallery}>
              {Array.from({ length: 9 }).map((_, index) => (
                <div className={styles[`destination${index + 1}`]} key={index}>
                  <Skeleton height={280} />
                </div>
              ))}
            </div>
          </div>
        ) : (
          <>
            {" "}
            <h3 className="new_ui_heading">{heading}</h3>
            <div className={`${styles.destination_gallery} m_0`}>
              {themes?.length > 0 ? (
                themes?.map((item, index) => {
                  return (
                    <a
                      href={`/themes/${item?.handle}`}
                      className={styles[`destination${index + 1}`]}
                      key={index}
                    >
                      <img
                        src={
                          item?.featuredImage
                            ? item?.featuredImage
                            : imgNotFound
                        }
                        alt={item?.title}
                      />
                      <span>{item?.title}</span>
                    </a>
                  );
                })
              ) : (
                <NoDataFound />
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ThemesGallery;
